@if (tabsFormGroup && tabOptions) {
  <form [formGroup]="tabsFormGroup" class="flex gap-1 items-center shrink-0 flex-1 max-w-full py-[0.1875rem] px-[0.1875rem] ml-[-0.1875rem] overflow-x-auto">
    <p-selectButton
      class="
        [&.p-selectbutton]:flex-nowrap
        [&.p-selectbutton]:gap-1
        [&.p-selectbutton]:bg-transparent
        [&.p-selectbutton]:border-none
        [&.p-selectbutton]:py-0
        [&_.p-togglebutton]:shrink-0
        [&_.p-togglebutton]:h-6
        [&_.p-togglebutton]:!px-[0.625rem]
        [&_.p-togglebutton]:!pt-[0.3125rem]
        [&_.p-togglebutton]:!pb-[0.375rem]
        lg:[&_.p-togglebutton]:!pt-[0.1875rem]
        lg:[&_.p-togglebutton]:!pb-[0.25rem]
        [&_.p-togglebutton]:rounded
        [&_.p-togglebutton]:bg-(--p-neutral-500)
        [&_.p-togglebutton]:border-none
        [&_.p-togglebutton]:text-(--p-primary-600)
        [&_.p-togglebutton]:text-[0.6875rem]
        [&_.p-togglebutton]:font-medium
        [&_.p-togglebutton]:leading-[150%]
        [&_.p-togglebutton:hover]:bg-(--p-neutral-700)
        [&_.p-togglebutton.p-togglebutton-checked]:bg-(--p-primary-500)
        [&_.p-togglebutton.p-togglebutton-checked]:text-(--p-white)
        [&_.p-togglebutton.p-togglebutton-checked:hover]:bg-(--p-primary-600)
      "
      [allowEmpty]="false"
      [options]="tabOptions"
      formControlName="tab">
      <ng-template #item let-option>
        {{ option.label | translate }}
      </ng-template>
    </p-selectButton>
  </form>
}
